import React, { useState } from 'react'
import Plus from '../icons/Plus'
import Modal from './Modal'
import TypeAnswerQuestionInput from './TypeAnswerQuestion'
import FillTheGapQuestionInput from './FillTheGapQuestion'

type Props = {}

const AddExerciseButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleModal = () => setIsOpen(!isOpen)
  const [questionType, setQuestionType] = useState<'type_answer' | 'fill_gap'>('type_answer')

  return (
    <>
      <div className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer" onClick={toggleModal}>
        <div className="text-white w-5 h-5">
          <Plus />
        </div>
        <div className="text-14 font-semibold text-white">Add Exercise</div>
      </div>
      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        <div className="bg-white rounded-xl p-4 w-[500px] h-[fit-content] mt-20">
          <div className="text-18 font-semibold">Add Exercise</div>
          <div className="h-4" />
          <div>
            <div className="text-14 font-medium">Question Type</div>
            <div className="h-2" />
            <select
              className="w-full border border-lightBorder/10 rounded-lg p-2"
              value={questionType}
              onChange={(e) => setQuestionType(e.target.value as 'type_answer' | 'fill_gap')}>
              <option value="type_answer">Type Answer</option>
              <option value="fill_gap">Fill the Gap</option>
            </select>
          </div>
          <div className="h-4" />
          {questionType === 'type_answer' && <TypeAnswerQuestionInput toggleModal={toggleModal} />}
          {questionType === 'fill_gap' && <FillTheGapQuestionInput toggleModal={toggleModal} />}
        </div>
      </Modal>
    </>
  )
}

export default AddExerciseButton
